$mol_hotkey $mol_hotkey2
	key *
	mod_ctrl false
	mod_alt false
	mod_shift false
